module.exports = __webpack_public_path__ + "img/close.c06e76f7.png";